import work from 'webworkify-webpack';
import axios from 'axios';
import React, { Component, createRef, createContext } from 'react';
import PropTypes from 'prop-types';
var settings = {
  apiKey: null,
  apiUrl: 'https://api.vuics.com/latest'
};

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

var worker = work(require.resolve('./worker.js'));
var audio_context, audio_stream;

var recorder = function recorder(source, silenceDetectionConfig) {
  silenceDetectionConfig = silenceDetectionConfig || {};
  silenceDetectionConfig.time = silenceDetectionConfig.hasOwnProperty('time') ? silenceDetectionConfig.time : 1500;
  silenceDetectionConfig.amplitude = silenceDetectionConfig.hasOwnProperty('amplitude') ? silenceDetectionConfig.amplitude : 0.2;
  var recording = false,
      currCallback,
      start,
      silenceCallback,
      visualizationCallback;
  var node = source.context.createScriptProcessor(4096, 1, 1);

  worker.onmessage = function (message) {
    var blob = message.data;
    currCallback(blob);
  };

  worker.postMessage({
    command: 'init',
    config: {
      sampleRate: source.context.sampleRate
    }
  });

  var record = function record(onSilence, visualizer) {
    silenceCallback = onSilence;
    visualizationCallback = visualizer;
    start = Date.now();
    recording = true;
  };

  var stop = function stop() {
    recording = false;
  };

  var clear = function clear() {
    stop();
    worker.postMessage({
      command: 'clear'
    });
  };

  var exportWAV = function exportWAV(callback, sampleRate) {
    currCallback = callback;
    worker.postMessage({
      command: 'export',
      sampleRate: sampleRate
    });
  };

  var analyse = function analyse() {
    analyser.fftSize = 2048;
    var bufferLength = analyser.fftSize;
    var dataArray = new Uint8Array(bufferLength);
    var amplitude = silenceDetectionConfig.amplitude;
    var time = silenceDetectionConfig.time;
    analyser.getByteTimeDomainData(dataArray);

    if (typeof visualizationCallback === 'function') {
      visualizationCallback(dataArray, bufferLength);
    }

    for (var i = 0; i < bufferLength; i++) {
      // Normalize between -1 and 1.
      var curr_value_time = dataArray[i] / 128 - 1.0;

      if (curr_value_time > amplitude || curr_value_time < -1 * amplitude) {
        start = Date.now();
      }
    }

    var newtime = Date.now();
    var elapsedTime = newtime - start;

    if (elapsedTime > time) {
      silenceCallback();
    }
  };

  node.onaudioprocess = function (audioProcessingEvent) {
    if (!recording) {
      return;
    }

    worker.postMessage({
      command: 'record',
      buffer: [audioProcessingEvent.inputBuffer.getChannelData(0)]
    });
    analyse();
  };

  var analyser = source.context.createAnalyser();
  analyser.minDecibels = -90;
  analyser.maxDecibels = -10;
  analyser.smoothingTimeConstant = 0.85;
  source.connect(analyser);
  analyser.connect(node);
  node.connect(source.context.destination);
  return {
    record: record,
    stop: stop,
    clear: clear,
    exportWAV: exportWAV
  };
};

var AudioRecorder = function AudioRecorder() {
  var requestDevice = function requestDevice() {
    if (typeof audio_context === 'undefined') {
      window.AudioContext = window.AudioContext || window.webkitAudioContext;
      audio_context = new AudioContext();
    }

    return navigator.mediaDevices.getUserMedia({
      audio: true
    }).then(function (stream) {
      audio_stream = stream;
    });
  };

  var createRecorder = function createRecorder(silenceDetectionConfig) {
    return recorder(audio_context.createMediaStreamSource(audio_stream), silenceDetectionConfig);
  };

  var audioContext = function audioContext() {
    return audio_context;
  };

  return {
    requestDevice: requestDevice,
    createRecorder: createRecorder,
    audioContext: audioContext
  };
};

var recorder$1;
var audioRecorder;
var checkAudioSupport;
var audioSupported;
var playbackSource;
var UNSUPPORTED = 'Audio is not supported.';

function AudioControl() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  this.checkAudioSupport = options.checkAudioSupport !== false;
  console.log('checkAudioSupport:', checkAudioSupport);

  function startRecording() {
    var onSilence = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
    var visualizer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
    var silenceDetectionConfig = arguments.length > 2 ? arguments[2] : undefined;
    audioSupported = audioSupported !== false;

    if (!audioSupported) {
      throw new Error(UNSUPPORTED);
    }

    recorder$1 = audioRecorder.createRecorder(silenceDetectionConfig);
    recorder$1.record(onSilence, visualizer);
  }

  function stopRecording() {
    audioSupported = audioSupported !== false;

    if (!audioSupported) {
      throw new Error(UNSUPPORTED);
    }

    recorder$1.stop();
  }

  function exportWAV() {
    var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {
      throw new Error('You must pass a callback function to export.');
    };
    var sampleRate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 16000;
    audioSupported = audioSupported !== false;

    if (!audioSupported) {
      throw new Error(UNSUPPORTED);
    }

    recorder$1.exportWAV(callback, sampleRate);
    recorder$1.clear();
  }

  function playHtmlAudioElement(buffer, callback) {
    if (typeof buffer === 'undefined') {
      return;
    }

    var audio = document.createElement('audio');
    audio.src = window.URL.createObjectURL(new Blob([buffer]));
    audio.addEventListener('ended', function () {
      audio.currentTime = 0;

      if (typeof callback === 'function') {
        callback();
      }
    });
    audio.play();
  }

  function play(buffer, callback) {
    if (typeof buffer === 'undefined') {
      return;
    }

    var myBlob = new Blob([buffer]);
    var fileReader = new FileReader();

    fileReader.onload = function onload() {
      playbackSource = audioRecorder.audioContext().createBufferSource();
      audioRecorder.audioContext().decodeAudioData(this.result, function (buf) {
        playbackSource.buffer = buf;
        playbackSource.connect(audioRecorder.audioContext().destination);

        playbackSource.onended = function (event) {
          if (typeof callback === 'function') {
            callback();
          }
        };

        playbackSource.start(0);
      });
    };

    fileReader.readAsArrayBuffer(myBlob);
  }

  function stop() {
    if (typeof playbackSource === 'undefined') {
      return;
    }

    playbackSource.stop();
  }

  function clear() {
    recorder$1.clear();
  }

  function supportsAudio() {
    var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};

    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      audioRecorder = AudioRecorder();
      audioRecorder.requestDevice().then(function (stream) {
        audioSupported = true;
        callback(audioSupported);
      }).catch(function (error) {
        console.log('audioRecorder requestDevice error', error);
        audioSupported = false;
        callback(audioSupported);
      });
    } else {
      audioSupported = false;
      callback(audioSupported);
    }
  }

  if (this.checkAudioSupport) {
    supportsAudio();
  }

  return {
    startRecording: startRecording,
    stopRecording: stopRecording,
    exportWAV: exportWAV,
    play: play,
    stop: stop,
    clear: clear,
    playHtmlAudioElement: playHtmlAudioElement,
    supportsAudio: supportsAudio
  };
}

var DEFAULT_CONTENT_TYPE = 'audio/x-l16; sample-rate=16000';
var DEFAULT_USER_ID = 'userId';
var DEFAULT_ACCEPT_HEADER_VALUE = 'audio/mpeg';
var MESSAGES = Object.freeze({
  PASSIVE: 'Passive',
  LISTENING: 'Listening',
  SENDING: 'Sending',
  SPEAKING: 'Speaking'
});
var audioControl = new AudioControl({
  checkAudioSupport: false
});

var bufferToArrayBuffer = function bufferToArrayBuffer(buffer) {
  var ab = new ArrayBuffer(buffer.data.length);
  var view = new Uint8Array(ab);

  for (var i = 0; i < buffer.data.length; ++i) {
    view[i] = buffer.data[i];
  }

  return ab;
};

function Conversation(config, onStateChange, onSuccess, onError, onAudioData) {
  var currentState;
  this.config = applyDefaults(config);
  this.vuiConfig = this.config.vuiConfig;
  this.messages = MESSAGES;

  onStateChange = onStateChange || function () {
    /* no op */
  };

  this.onSuccess = onSuccess || function () {
    /* no op */
  };

  this.onError = onError || function () {
    /* no op */
  };

  this.onAudioData = onAudioData || function () {
    /* no op */
  };

  if (!this.config.vuiConfig.name) {
    this.onError('A VUI name must be provided.');
    return;
  }

  this.onSilence = function onSilence() {
    if (config.silenceDetection) {
      audioControl.stopRecording();
      currentState.advanceConversation();
    }
  };

  this.stopRecord = function stopRecord() {
    audioControl.stopRecording();
    audioControl.clear();
    currentState = new Initial(currentState.state);
    var state = currentState.state;
    onStateChange(state.message);
    this.reset();
  };

  this.transition = function transition(conversation) {
    currentState = conversation;
    var state = currentState.state;
    onStateChange(state.message);

    if (state.message === state.messages.SENDING || state.message === state.messages.SPEAKING) {
      currentState.advanceConversation();
    }

    if (state.message === state.messages.SENDING && !this.config.silenceDetection) {
      audioControl.stopRecording();
    }
  };

  this.advanceConversation = function advanceConversation() {
    audioControl.supportsAudio(function supportsAudio(supported) {
      if (supported) {
        currentState.advanceConversation();
      } else {
        onError('Audio is not supported.');
      }
    });
  };

  this.updateConfig = function updateConfig(config) {
    this.config = applyDefaults(config);
    this.vuiConfig = this.config.vuiConfig;
  };

  this.reset = function reset() {
    audioControl.clear();
    currentState = new Initial(currentState.state);
  };

  currentState = new Initial(this);
  return {
    advanceConversation: this.advanceConversation,
    updateConfig: this.updateConfig,
    reset: this.reset,
    stopRecord: this.stopRecord
  };
}

function Initial(state) {
  this.state = state;
  state.message = state.messages.PASSIVE;

  this.advanceConversation = function advanceConversation() {
    audioControl.startRecording(state.onSilence, state.onAudioData, state.config.silenceDetectionConfig);
    state.transition(new Listening(state));
  };
}

function Listening(state) {
  this.state = state;
  state.message = state.messages.LISTENING;

  this.advanceConversation = function advanceConversation() {
    audioControl.exportWAV(function exportWAV(blob) {
      state.audioInput = blob;
      state.transition(new Sending(state));
    });
  };
}

function Sending(state) {
  this.state = state;
  state.message = state.messages.SENDING;

  this.advanceConversation = function advanceConversation() {
    state.vuiConfig.inputStream = state.audioInput;
    var data = new FormData();
    data.append('inputStream', state.vuiConfig.inputStream);
    data.append('name', state.vuiConfig.name);
    data.append('contentType', state.vuiConfig.contentType);
    data.append('userId', state.vuiConfig.userId);
    data.append('accept', state.vuiConfig.accept);
    var url = "".concat(settings.apiUrl, "/vui-server/content");
    var headers = {};

    if (state.vuiConfig.authToken) {
      url = "".concat(settings.apiUrl, "/server/content");
      headers['Authorization'] = state.vuiConfig.authToken;
    } else if (state.vuiConfig.apiKey) {
      headers['X-API-key'] = state.vuiConfig.apiKey;
    } else {
      headers['X-API-key'] = settings.apiKey;
    }

    axios({
      method: 'post',
      url: url,
      data: data,
      headers: headers
    }).then(function (response) {
      response.data.audioStream = bufferToArrayBuffer(response.data.audioStream);
      state.audioOutput = response.data;
      state.transition(new Speaking(state));
      state.onSuccess(response.data);
    }).catch(function (err) {
      state.onError(err);
      state.transition(new Initial(state));
    });
  };
}

function Speaking(state) {
  this.state = state;
  state.message = state.messages.SPEAKING;

  this.advanceConversation = function advanceConversation() {
    if (state.audioOutput.contentType === 'audio/mpeg') {
      audioControl.play(state.audioOutput.audioStream, function play() {
        if (state.audioOutput.dialogState === 'ReadyForFulfillment' || state.audioOutput.dialogState === 'Fulfilled' || state.audioOutput.dialogState === 'Failed' || !state.config.silenceDetection) {
          state.transition(new Initial(state));
        } else {
          audioControl.startRecording(state.onSilence, state.onAudioData, state.config.silenceDetectionConfig);
          state.transition(new Listening(state));
        }
      });
    } else {
      state.transition(new Initial(state));
    }
  };
}

function applyDefaults(config) {
  config = config || {};
  config.silenceDetection = config.hasOwnProperty('silenceDetection') ? config.silenceDetection : true;
  var vuiConfig = config.vuiConfig || {};
  vuiConfig.name = vuiConfig.hasOwnProperty('name') ? vuiConfig.name : '';
  vuiConfig.authToken = vuiConfig.hasOwnProperty('authToken') ? vuiConfig.authToken : '';
  vuiConfig.apiKey = vuiConfig.hasOwnProperty('apiKey') ? vuiConfig.apiKey : '';
  vuiConfig.contentType = vuiConfig.hasOwnProperty('contentType') ? vuiConfig.contentType : DEFAULT_CONTENT_TYPE;
  vuiConfig.userId = vuiConfig.hasOwnProperty('userId') ? vuiConfig.userId : DEFAULT_USER_ID;
  vuiConfig.accept = vuiConfig.hasOwnProperty('accept') ? vuiConfig.accept : DEFAULT_ACCEPT_HEADER_VALUE;
  config.vuiConfig = vuiConfig;
  return config;
}

var _createContext = createContext('VuicsContext'),
    Provider = _createContext.Provider,
    Consumer = _createContext.Consumer;

var Vuics = /*#__PURE__*/function (_Component) {
  _inherits(Vuics, _Component);

  function Vuics(props) {
    var _this;

    _classCallCheck(this, Vuics);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Vuics).call(this, props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      transcript: '',
      listening: false,
      state: 'Passive',
      message: 'Click to Speak!'
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "componentDidMount", function () {
      window.addEventListener('resize', _this.setCanvasDimensions);

      _this.setCanvasDimensions();

      _this.canvasCtx = _this.canvasRef.current.getContext('2d');
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "componentWillUnmount", function () {
      window.removeEventListener('resize', _this.setCanvasDimensions);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "setCanvasDimensions", function () {
      _this.setState(function () {
        return {
          width: _this.canvasWrapperRef.current.clientWidth,
          height: _this.canvasWrapperRef.current.clientHeight
        };
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "visualizeAudioBuffer", function (dataArray, bufferLength) {
      var animationId;

      _this.canvasCtx.clearRect(0, 0, _this.canvasRef.current.clientWidth, _this.canvasRef.current.clientHeight);

      var draw = function draw() {
        if (!_this.state.listening) {
          return;
        }

        _this.canvasCtx.fillStyle = _this.props.fillStyle;

        _this.canvasCtx.fillRect(0, 0, _this.canvasRef.current.clientWidth, _this.canvasRef.current.clientHeight);

        _this.canvasCtx.lineWidth = _this.props.lineWidth;
        _this.canvasCtx.strokeStyle = _this.props.strokeStyle;

        _this.canvasCtx.beginPath();

        var sliceWidth = _this.canvasRef.current.clientWidth * 1.0 / bufferLength;
        var x = 0;

        for (var i = 0; i < bufferLength; i++) {
          var v = dataArray[i] / 128.0;
          var y = v * _this.canvasRef.current.clientHeight / 2;

          if (i === 0) {
            _this.canvasCtx.moveTo(x, y);
          } else {
            _this.canvasCtx.lineTo(x, y);
          }

          x += sliceWidth;
        }

        _this.canvasCtx.lineTo(_this.canvasRef.current.width, _this.canvasRef.height / 2);

        _this.canvasCtx.stroke();
      };

      if (typeof animationId === 'undefined') {
        animationId = window.requestAnimationFrame(draw);
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onChangeState", function (state) {
      console.log('state:', state);

      if (state === 'Listening') {
        _this.setState(function () {
          return {
            state: state,
            listening: true
          };
        });
      }

      if (state === 'Sending') {
        _this.setState(function () {
          return {
            state: state,
            listening: false
          };
        });

        _this.canvasCtx.fillRect(0, 0, _this.canvasRef.current.clientWidth, _this.canvasRef.current.clientHeight);

        _this.canvasCtx.clearRect(0, 0, _this.canvasRef.current.clientWidth, _this.canvasRef.current.clientHeight);
      }

      if (state === 'Passive') {
        _this.setState(function () {
          return {
            state: state,
            listening: false
          };
        });

        _this.canvasCtx.fillRect(0, 0, _this.canvasRef.current.clientWidth, _this.canvasRef.current.clientHeight);

        _this.canvasCtx.clearRect(0, 0, _this.canvasRef.current.clientWidth, _this.canvasRef.current.clientHeight);
      }

      if (state === 'Speaking') {
        _this.setState(function () {
          return {
            state: state,
            listening: false
          };
        });
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onData", function (data) {
      console.log('data:', data);
      console.log('Transcript:', data.inputTranscript, ', Response:', data.message);

      _this.setState(function () {
        return {
          transcript: data.inputTranscript,
          message: data.message
        };
      });

      _this.props.onConversationData(data);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onError", function (error) {
      console.log('onError error: ', error);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onClick", function () {
      if (_this.state.state === 'Listening' || _this.state.state === 'Sending' || _this.state.state === 'Speaking') {
        console.log('this.state.state: ', _this.state.state);

        _this.conversation.stopRecord();

        return;
      }

      _this.conversation = new Conversation({
        vuiConfig: {
          name: _this.props.name,
          authToken: _this.props.authToken,
          apiKey: _this.props.apiKey
        }
      }, _this.onChangeState, _this.onData, _this.onError, _this.visualizeAudioBuffer);

      _this.conversation.advanceConversation();
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "render", function () {
      return React.createElement(Provider, {
        value: {
          // eslint-disable-line react-perf/jsx-no-new-object-as-prop
          buttonRef: _this.buttonRef,
          canvasRef: _this.canvasRef,
          canvasWrapperRef: _this.canvasWrapperRef,
          state: _this.state.state,
          transcript: _this.state.transcript,
          message: _this.state.message,
          width: _this.state.width,
          height: _this.state.height,
          onClick: _this.onClick
        }
      }, _this.props.children);
    });

    _this.buttonRef = createRef();
    _this.canvasWrapperRef = createRef();
    _this.canvasRef = createRef();
    _this.conversation = null;
    _this.canvasCtx = null;
    return _this;
  }

  return Vuics;
}(Component);

_defineProperty(Vuics, "propTypes", {
  children: PropTypes.node.isRequired,
  name: PropTypes.string.isRequired,
  authToken: PropTypes.string,
  apiKey: PropTypes.string,
  onConversationData: PropTypes.func.isRequired,
  fillStyle: PropTypes.string,
  lineWidth: PropTypes.number,
  strokeStyle: PropTypes.string
});

_defineProperty(Vuics, "defaultProps", {
  fillStyle: 'rgb(27,28,29)',
  lineWidth: 2,
  strokeStyle: 'rgb(33,186,70)'
});

var ButtonDefault = function ButtonDefault(_ref) {
  var className = _ref.className;
  return React.createElement(Consumer, null, function (_ref2) {
    var buttonRef = _ref2.buttonRef,
        onClick = _ref2.onClick,
        children = _ref2.children,
        state = _ref2.state,
        message = _ref2.message;
    return React.createElement("button", {
      ref: buttonRef,
      type: "button",
      tabIndex: "0",
      onClick: onClick,
      className: className
    }, message);
  });
};

ButtonDefault.propTypes = {
  className: PropTypes.string.isRequired
};

var Oscilloscope = /*#__PURE__*/function (_Component) {
  _inherits(Oscilloscope, _Component);

  function Oscilloscope() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Oscilloscope);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Oscilloscope)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "render", function () {
      return React.createElement(Consumer, null, function (_ref) {
        var canvasWrapperRef = _ref.canvasWrapperRef,
            canvasRef = _ref.canvasRef,
            width = _ref.width,
            height = _ref.height;
        return React.createElement("div", {
          className: _this.props.canvasWrapperClassName,
          ref: canvasWrapperRef
        }, React.createElement("canvas", {
          className: _this.props.canvasClassName,
          ref: canvasRef,
          width: width,
          height: height
        }));
      });
    });

    return _this;
  }

  return Oscilloscope;
}(Component);

_defineProperty(Oscilloscope, "propTypes", {
  canvasWrapperClassName: PropTypes.string.isRequired,
  canvasClassName: PropTypes.string.isRequired
});

var synth = window.speechSynthesis;
var voices;

var onVoicesChanged = function onVoicesChanged() {
  voices = synth.getVoices(); // console.log('voices:', voices);
};

onVoicesChanged();

if (speechSynthesis.onvoiceschanged !== undefined) {
  speechSynthesis.onvoiceschanged = onVoicesChanged;
}

var Synthesizer = function Synthesizer() {
  _classCallCheck(this, Synthesizer);
};

_defineProperty(Synthesizer, "speak", function (_ref) {
  var phrase = _ref.phrase;

  if (synth.speaking) {
    console.error('Synthesizer is already speaking.');
    return;
  }

  var utterThis = new SpeechSynthesisUtterance(phrase);

  utterThis.onend = function (event) {// console.log('SpeechSynthesisUtterance.onend');
  };

  utterThis.onerror = function (event) {
    console.error('An error has occurred with the speech synthesis:', event.error);
  }; // TODO: select voices and speech params


  utterThis.voice = voices[0];
  utterThis.pitch = 1;
  utterThis.rate = 1;
  synth.speak(utterThis);
});
/*
The MIT License (MIT)

Original work Copyright (c) 2016 Tal Ater
Modified work Copyright (c) 2018 Artem Arakcheev

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.
*/
// Version: 2.6.1-0.0.1


var recognizerFactory = function recognizerFactory(root) {
  var recognizer; // Get the SpeechRecognition object, while handling browser prefixes

  var SpeechRecognition = root.SpeechRecognition || root.webkitSpeechRecognition || root.mozSpeechRecognition || root.msSpeechRecognition || root.oSpeechRecognition; // Check browser support
  // This is done as early as possible, to make it as fast as possible for unsupported browsers

  if (!SpeechRecognition) {
    var _ref;

    console.error('The browser does not support speech recognition'); // return null;

    return _ref = {
      isSupported: function isSupported() {
        return false;
      },
      init: function init() {},
      start: function start() {},
      abort: function abort() {},
      pause: function pause() {},
      resume: function resume() {},
      debug: function debug() {}
    }, _defineProperty(_ref, "debug", function debug() {}), _defineProperty(_ref, "setLanguage", function setLanguage() {}), _defineProperty(_ref, "addCommands", function addCommands() {}), _defineProperty(_ref, "removeCommands", function removeCommands() {}), _defineProperty(_ref, "addCallback", function addCallback() {}), _defineProperty(_ref, "removeCallback", function removeCallback() {}), _defineProperty(_ref, "isListening", function isListening() {}), _defineProperty(_ref, "getSpeechRecognizer", function getSpeechRecognizer() {}), _defineProperty(_ref, "trigger", function trigger() {}), _ref;
  }

  var commandsList = [];
  var recognition;
  var callbacks = {
    start: [],
    error: [],
    end: [],
    soundstart: [],
    result: [],
    resultMatch: [],
    resultNoMatch: [],
    errorNetwork: [],
    errorPermissionBlocked: [],
    errorPermissionDenied: []
  };
  var autoRestart;
  var lastStartedAt = 0;
  var autoRestartCount = 0;
  var debugState = true;
  var debugStyle = 'font-weight: bold; color: #00f;';
  var pauseListening = false;
  var _isListening = false; // The command matching code is a modified version of Backbone.Router by Jeremy Ashkenas, under the MIT license.

  var optionalParam = /\s*\((.*?)\)\s*/g;
  var optionalRegex = /(\(\?:[^)]+\))\?/g;
  var namedParam = /(\(\?)?:\w+/g;
  var splatParam = /\*\w+/g;
  var escapeRegExp = /[\-{}\[\]+?.,\\\^$|#]/g;

  var commandToRegExp = function commandToRegExp(command) {
    command = command.replace(escapeRegExp, '\\$&').replace(optionalParam, '(?:$1)?').replace(namedParam, function (match, optional) {
      return optional ? match : '([^\\s]+)';
    }).replace(splatParam, '(.*?)').replace(optionalRegex, '\\s*$1?\\s*');
    return new RegExp('^' + command + '$', 'i');
  };

  var invokeCallbacks = function invokeCallbacks(callbacks) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    callbacks.forEach(function (callback) {
      callback.callback.apply(callback.context, args);
    });
  };

  var isInitialized = function isInitialized() {
    return recognition !== undefined;
  };

  var logMessage = function logMessage(text, extraParameters) {
    if (text.indexOf('%c') === -1 && !extraParameters) {
      console.log(text);
    } else {
      console.log(text, extraParameters || debugStyle);
    }
  };

  var initIfNeeded = function initIfNeeded() {
    if (!isInitialized()) {
      recognizer.init({}, false);
    }
  };

  var registerCommand = function registerCommand(command, callback, originalPhrase) {
    commandsList.push({
      command: command,
      callback: callback,
      originalPhrase: originalPhrase
    });

    if (debugState) {
      logMessage('Command successfully loaded: %c' + originalPhrase, debugStyle);
    }
  };

  var parseResults = function parseResults(results) {
    invokeCallbacks(callbacks.result, results);
    var commandText;

    for (var i = 0; i < results.length; i++) {
      commandText = results[i].trim();

      if (debugState) {
        logMessage('Speech recognized: %c' + commandText, debugStyle);
      }

      for (var j = 0, l = commandsList.length; j < l; j++) {
        var currentCommand = commandsList[j];
        var result = currentCommand.command.exec(commandText);

        if (result) {
          var parameters = result.slice(1);

          if (debugState) {
            logMessage('command matched: %c' + currentCommand.originalPhrase, debugStyle);

            if (parameters.length) {
              logMessage('with parameters', parameters);
            }
          }

          currentCommand.callback.apply(this, parameters);
          invokeCallbacks(callbacks.resultMatch, commandText, currentCommand.originalPhrase, results);
          return;
        }
      }
    }

    invokeCallbacks(callbacks.resultNoMatch, results);
  };

  recognizer = {
    isSupported: function isSupported() {
      return true;
    },
    init: function init(commands) {
      var resetCommands = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      if (recognition && recognition.abort) {
        recognition.abort();
      }

      recognition = new SpeechRecognition();
      recognition.maxAlternatives = 5; // In HTTPS, turn off continuous mode for faster results.
      // In HTTP,  turn on  continuous mode for much slower results, but no repeating security notices

      recognition.continuous = root.location.protocol === 'http:';
      recognition.lang = 'en-US'; // recognition.lang = 'ru-RU';

      recognition.onstart = function () {
        _isListening = true;
        invokeCallbacks(callbacks.start);
      };

      recognition.onsoundstart = function () {
        invokeCallbacks(callbacks.soundstart);
      };

      recognition.onerror = function (event) {
        invokeCallbacks(callbacks.error, event);

        switch (event.error) {
          case 'network':
            invokeCallbacks(callbacks.errorNetwork, event);
            break;

          case 'not-allowed':
          case 'service-not-allowed':
            autoRestart = false;

            if (new Date().getTime() - lastStartedAt < 200) {
              invokeCallbacks(callbacks.errorPermissionBlocked, event);
            } else {
              invokeCallbacks(callbacks.errorPermissionDenied, event);
            }

            break;
        }
      };

      recognition.onend = function () {
        _isListening = false;
        invokeCallbacks(callbacks.end);

        if (autoRestart) {
          var timeSinceLastStart = new Date().getTime() - lastStartedAt;
          autoRestartCount += 1;

          if (autoRestartCount % 10 === 0) {
            if (debugState) {
              logMessage('Speech Recognition is repeatedly stopping and starting. Check that you are online and have opened only one window/tab with Speech Recognition in the browser.');
            }
          }

          if (timeSinceLastStart < 1000) {
            setTimeout(function () {
              recognizer.start({
                paused: pauseListening
              });
            }, 1000 - timeSinceLastStart);
          } else {
            recognizer.start({
              paused: pauseListening
            });
          }
        }
      };

      recognition.onresult = function (event) {
        if (pauseListening) {
          if (debugState) {
            logMessage('Speech heard, but recognizer is paused');
          }

          return false;
        }

        var SpeechRecognitionResult = event.results[event.resultIndex];
        var results = [];

        for (var k = 0; k < SpeechRecognitionResult.length; k++) {
          results[k] = SpeechRecognitionResult[k].transcript;
        }

        parseResults(results);
      };

      if (resetCommands) {
        commandsList = [];
      }

      if (commands.length) {
        this.addCommands(commands);
      }
    },
    start: function start(options) {
      initIfNeeded();
      options = options || {};

      if (options.paused !== undefined) {
        pauseListening = !!options.paused;
      } else {
        pauseListening = false;
      }

      if (options.autoRestart !== undefined) {
        autoRestart = !!options.autoRestart;
      } else {
        autoRestart = true;
      }

      if (options.continuous !== undefined) {
        recognition.continuous = !!options.continuous;
      }

      lastStartedAt = new Date().getTime();

      try {
        recognition.start();
      } catch (e) {
        if (debugState) {
          logMessage(e.message);
        }
      }
    },
    abort: function abort() {
      autoRestart = false;
      autoRestartCount = 0;

      if (isInitialized()) {
        recognition.abort();
      }
    },
    pause: function pause() {
      pauseListening = true;
    },
    resume: function resume() {
      recognizer.start();
    },
    debug: function debug() {
      var newState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      debugState = !!newState;
    },
    setLanguage: function setLanguage(language) {
      initIfNeeded();
      recognition.lang = language;
    },
    addCommands: function addCommands(commands) {
      var cb;
      initIfNeeded();

      for (var phrase in commands) {
        if (commands.hasOwnProperty(phrase)) {
          cb = root[commands[phrase]] || commands[phrase];

          if (typeof cb === 'function') {
            registerCommand(commandToRegExp(phrase), cb, phrase);
          } else if (_typeof(cb) === 'object' && cb.regexp instanceof RegExp) {
            registerCommand(new RegExp(cb.regexp.source, 'i'), cb.callback, phrase);
          } else {
            if (debugState) {
              logMessage('Can not register command: %c' + phrase, debugStyle);
            }

            continue;
          }
        }
      }
    },
    removeCommands: function removeCommands(commandsToRemove) {
      if (commandsToRemove === undefined) {
        commandsList = [];
      } else {
        commandsToRemove = Array.isArray(commandsToRemove) ? commandsToRemove : [commandsToRemove];
        commandsList = commandsList.filter(function (command) {
          for (var i = 0; i < commandsToRemove.length; i++) {
            if (commandsToRemove[i] === command.originalPhrase) {
              return false;
            }
          }

          return true;
        });
      }
    },
    addCallback: function addCallback(type, callback, context) {
      var cb = root[callback] || callback;

      if (typeof cb === 'function' && callbacks[type] !== undefined) {
        callbacks[type].push({
          callback: cb,
          context: context || this
        });
      }
    },
    removeCallback: function removeCallback(type, callback) {
      var compareWithCallbackParameter = function compareWithCallbackParameter(cb) {
        return cb.callback !== callback;
      };

      for (var callbackType in callbacks) {
        if (callbacks.hasOwnProperty(callbackType)) {
          if (type === undefined || type === callbackType) {
            if (callback === undefined) {
              callbacks[callbackType] = [];
            } else {
              callbacks[callbackType] = callbacks[callbackType].filter(compareWithCallbackParameter);
            }
          }
        }
      }
    },
    isListening: function isListening() {
      return _isListening && !pauseListening;
    },
    getSpeechRecognizer: function getSpeechRecognizer() {
      return recognition;
    },
    trigger: function trigger(sentences) {
      if (!recognizer.isListening()) {
        if (debugState) {
          if (!_isListening) {
            logMessage('Cannot trigger while recognizer is aborted');
          } else {
            logMessage('Speech heard, but recognizer is paused');
          }
        }

        return;
      }

      if (!Array.isArray(sentences)) {
        sentences = [sentences];
      }

      parseResults(sentences);
    }
  };
  return recognizer;
};

var Recognizer = recognizerFactory(window);

var initVuics = function initVuics(_ref) {
  var apiKey = _ref.apiKey,
      apiUrl = _ref.apiUrl;
  console.log('init');

  if (apiKey) {
    settings.apiKey = apiKey;
  }

  if (apiUrl) {
    settings.apiUrl = apiUrl;
  }
};

export { initVuics, Vuics, Consumer, ButtonDefault, Oscilloscope, Synthesizer, Recognizer };